import React, {useState, useEffect, useCallback} from 'react'
import './DateArea.scss'
import {Grid, Box} from '@material-ui/core'
import useGetReservationItemReducer from '../../state/reservation/get-reservation-status-states/reducer'
import {getReservationStatusStates} from '../../state/reservation/get-reservation-status-states/action'
import LoadingIndicator from '../ReservationConfiguration/LoadingIcon'
import moment from 'moment'
import useCalendarViewContext from '../../context/CalendarView'
import _ from 'lodash'
import {Search} from '@material-ui/icons'

export default function DateArea({
  group_ids,
  setItemData,
  apiStatus,
  setItemUpdated,
  itemUpdated,
  tabActive,
  search,
}) {
  const [reservationItems, dispatch] = useGetReservationItemReducer()
  const [offset, setOffset] = useState(0)
  const [stillLoading, setStillLoading] = useState(true)
  const {views} = useCalendarViewContext()
  const [clickItem, setClickItem] = useState('')
  const [hideUpdatedItems, setHideUpdatedItems] = useState([])
  const [fullRecord, setFullRecord] = useState({data: {}})

  const tryCallApi = useCallback(
    params => {
      if (!!!params.status || !!!params.group_ids || params.group_ids.length === 0) return
      getReservationStatusStates(dispatch, params)
      setStillLoading(false)
    },
    [dispatch]
  )

  useEffect(() => {
    tryCallApi({offset: offset, limit: 30, status: apiStatus, group_ids: group_ids, query: search})
  }, [apiStatus, group_ids, offset, tryCallApi, search])

  useEffect(() => {
    if (!_.isEmpty(itemUpdated)) {
      setHideUpdatedItems([...hideUpdatedItems, itemUpdated.uid])
      setItemUpdated({})
    }
    // eslint-disable-next-line
  }, [itemUpdated])

  useEffect(() => {
    if (!_.isEmpty(reservationItems.data)) {
      setFullRecord({data: _.merge(fullRecord.data, reservationItems.data)})
    }
    // eslint-disable-next-line
  }, [reservationItems])

  function handleClick(event, item) {
    setClickItem(item.uid)
    setItemData(item)
  }

  const handleVScroll = e => {
    // lazy load here
    if (
      Math.round(e.currentTarget.offsetHeight + e.currentTarget.scrollTop) >=
        Math.round(e.currentTarget.scrollHeight) &&
      !allLoaded
    ) {
      setOffset(offset + 1)
    }
  }

  const handleDateNames = () => {
    if (tabActive === 'previous') {
      return Object.keys(fullRecord.data).sort((a, b) => new Date(b) - new Date(a))
    } else {
      return Object.keys(fullRecord.data).sort((a, b) => new Date(a) - new Date(b))
    }
  }

  const allLoaded = (offset + 1) * 30 >= reservationItems.total

  function getHighlightedText(text, highlight) {
    // Split text on highlight term, include term itself into parts, ignore case
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'))
    return (
      <span>
        {' '}
        {parts.map((part, i) => (
          <span
            key={i}
            style={
              part.toLowerCase() === highlight.toLowerCase() ? {backgroundColor: '#ffef5b'} : {}
            }
          >
            {part}
          </span>
        ))}{' '}
      </span>
    )
  }

  return (
    <div
      className="ap-scrollbar"
      style={{height: '610px', overflowY: 'auto', position: 'relative'}}
      onScroll={handleVScroll}
    >
      {!stillLoading && (
        <div>
          {handleDateNames().map(keyName => {
            const dateTitle = moment(new Date(keyName)).format('dddd, MMMM DD YYYY')
            let dateItems = []
            const items = fullRecord.data[keyName].map(item => {
              let color = '#26d779'
              dateItems.push(item.uid)
              if (views?.data) {
                const view = views?.data.find(f => f?.group_view?.entity_id === item.entity_id)
                if (view?.group_view) {
                  color = view.group_view.color
                }
              }
              let itemNames = ''
              const itemTotal = item.items.length - 3
              item.items.map((name, index) => {
                if (index < 3) {
                  if (itemNames === '') {
                    itemNames = name.primary || name.secondary
                  } else {
                    itemNames = `${itemNames}, ${name.primary || name.secondary}`
                  }
                }
                return itemNames
              })
              return (
                <div
                  onClick={event => handleClick(event, item)}
                  key={item.uid}
                  className="ap-reservation-date-area__item-hover"
                  style={{backgroundColor: clickItem === item.uid ? '#edf4fc' : ''}}
                  hidden={hideUpdatedItems.some(d => item.uid === d)}
                >
                  <div
                    container
                    style={{borderBottom: '1px solid #DCDCDC', padding: '10px', fontSize: '14px'}}
                  >
                    <div
                      style={{
                        display: 'inline-block',
                        marginTop: '8px',
                        marginRight: '5px',
                        borderRadius: '50%',
                        backgroundColor: color,
                        width: '8px',
                        height: '8px',
                      }}
                    />
                    <div style={{display: '-webkit-inline-box', marginRight: '10px'}}>
                      <Box color="#5c5d5e">Reservation –&nbsp;</Box>

                      {getHighlightedText(item.uid, search) ? (
                        getHighlightedText(item.uid, search)
                      ) : (
                        <div>{`${item.uid}`}</div>
                      )}
                    </div>
                    <div style={{display: '-webkit-inline-box', marginRight: '10px'}}>
                      <Box color="#5c5d5e">For –&nbsp;</Box>

                      {getHighlightedText(item.reserve_for.value, search) ? (
                        getHighlightedText(item.reserve_for.value, search)
                      ) : (
                        <div>{`${item.reserve_for.value}`}</div>
                      )}
                    </div>
                    <div
                      style={{display: '-webkit-inline-box', width: '150px', marginRight: '26px'}}
                    >
                      <Box color="#5c5d5e">Items –&nbsp;</Box>
                      <Box
                        style={{
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          width: itemTotal > 0 ? '80%' : '100%',
                        }}
                      >
                        {`${itemNames}`}
                      </Box>
                    </div>
                    {itemTotal > 0 && (
                      <div style={{display: 'inline-block'}}>{`+${itemTotal}`}</div>
                    )}
                  </div>
                </div>
              )
            })

            return (
              <div key={keyName}>
                <div
                  className="ap-reservation-date-area__date-title"
                  hidden={_.difference(dateItems, hideUpdatedItems).length === 0}
                >
                  {dateTitle}
                </div>

                <div style={{marginBottom: '30px'}}>{items}</div>
              </div>
            )
          })}
        </div>
      )}
      {reservationItems.isLoading && (
        <LoadingIndicator
          style={{
            padding: 8,
            paddingTop: offset === 0 ? 120 : 0,
            background: '#fff',
            zIndex: 1299,
            height: 'auto',
          }}
        />
      )}
      {!reservationItems.isLoading && !stillLoading && _.isEmpty(reservationItems.data) && (
        <div className="ap-reservation-date-area__no-data">No results found!</div>
      )}
    </div>
  )
}
